import { render, staticRenderFns } from "./MoreVideo.vue?vue&type=template&id=4cdaf7c4&scoped=true&"
import script from "./MoreVideo.vue?vue&type=script&lang=js&"
export * from "./MoreVideo.vue?vue&type=script&lang=js&"
import style0 from "./MoreVideo.vue?vue&type=style&index=0&id=4cdaf7c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdaf7c4",
  null
  
)

export default component.exports